<template>
    <div class="login">
      <div class="login-title">
        <img src="../../assets/images/logo.png" />
        <h3>广东绀发防伪码系统</h3>
      </div>
      <van-form @submit="onSubmit">
        <van-field
          v-model="phone"
          name="手机号"
          label="手机号"
          placeholder="手机号"
          :rules="[{ required: true, message: '请填写手机号'}]"
        />
        <van-field
          v-model="password"
          type="password"
          name="密码"
          label="密 码"
          placeholder="密码"
          :rules="[{ required: true, message: '请填写密码' }]"
        />
        <div style="margin: 16px;">
          <van-button round block type="info" class="form-sub" native-type="submit">立即登录</van-button>
        </div>
      </van-form>
    </div>
</template>

<script>
  import { Form, Button } from 'vant'

  export default {
    name: 'login',
    components: {
      [Form.name]: Form,
      [Button.name]: Button
    },
    data() {
      return {
        isLaoding: true,
        phone: '',
        password: '',
      };
    },
    created() {
      if(window.localStorage.getItem('auth')){
        this.$router.push({name:'index'})
        return
      }
    },
    methods: {
      onSubmit(values) {
        if(this.phone.trim() == ''){
          this.$toast('手机号不能为空')
          return
        }
        if(!this.common.verifyPhone(this.phone)){
          this.$toast('请输入正确的手机号码');
          return
        }
        if(this.password.trim() == ''){
          this.$toast('密码不能为空')
          return
        }
        if(this.password.length < 6){
          this.$toast('密码长度不能小于六位')
          return
        }
        let self = this
        this.$toast.loading({
          message: '登录中...',
          forbidClick: true,
        })
        this.$api.post('fw/auth/login', {'username':this.phone, 'password':this.password}, r=>{
          if(r.status === 200){
            window.localStorage.setItem('auth', true);
            window.localStorage.setItem('uid', r.result.id);
            self.$store.dispatch('logined', r.result.id)
            self.$router.push({name: 'index'})
            this.$toast.clear()
          }else{
            this.$toast('登录失败')
            return
          }
        })
      },
    },
  }
</script>

<style scoped>
  .login{
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    position: fixed;
    overflow: hidden;
    padding-top:13%;
  }
  .login .login-title{
    text-align: center;
  }
  .login .login-title img{
    width: 230px;
  }
  .login .login-title h3{
    font-size: 16px;
    font-weight: normal;
  }
  .login-pwd{
    overflow: hidden;
    padding:15px 15px 5px;
    font-size: 14px;
  }
  .login-pwd a{
    color:#ED6B0D;
  }
  .form-sub{
    background: #ED6B0D;
    border:1px solid #ED6B0D;
  }
</style>



// WEBPACK FOOTER //
// src/views/registers/login.vue